import LazyLoad from "vanilla-lazyload";

document.addEventListener('DOMContentLoaded',function() {

   const myLazyLoad = new LazyLoad();
    
}, false);
